import { Theme } from '@blockanalitica/ui/package/types/src/theme/ThemeProvider';
import { ComponentStyle } from '@blockanalitica/ui/package/types/src/theme/types';

export function heatmapCell(theme: Theme): ComponentStyle {
  return {
    componentName: 'heatmapCell',
    baseStyle: {
      width: theme.sizes['0'],
      height: theme.sizes['0'],
      backgroundColor: theme.colors.foreground
    }
  };
}
